import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { PosterDashboardComponent } from './posters/poster-dashboard/poster-dashboard.component';
import { ViewPosterComponent } from './posters/view-poster/view-poster.component';
import { IsAuthenticatedGuard } from './_guards/isAuthenticated.gaurd';
import { ApplicationPipesModule } from './_shared/modules/application-pipes.module';
import { NgxImageZoomComponent } from './_controls/image-zoom/ngx-image-zoom.component';
import { PosterFeedbackComponent } from './posters/poster-feedback/poster-feedback.component';
import { PosterVisitorLogComponent } from './posters/poster-dashboard/visitor-log/poster-visitor-log.component';

@NgModule({
  declarations:[
    ViewPosterComponent,
    PosterDashboardComponent,
    NgxImageZoomComponent,
    PosterFeedbackComponent,
    PosterVisitorLogComponent
  ],
  entryComponents:[],
  imports: [
    NgbModalModule,
    ApplicationPipesModule,
    RouterModule.forChild([
      { path: ':posterSessionId/posters/:posterId', component: ViewPosterComponent, canActivate: [IsAuthenticatedGuard] },
      { path: ':posterSessionId/posters/:posterId/dashboard', component: PosterDashboardComponent, canActivate: [IsAuthenticatedGuard] },
    ])
  ]
})
  export class PostersModule{}
